import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function PersonalProfile(params) {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  
  return (
    <fieldset>
      <legend>{t("Personal Profile")}</legend>
      <input
        className="form-control"
        name="personalProfile"
        onChange={onChange}
        value={searchObject.personalProfile || ""}
      />
    </fieldset>
  );
}
